import React, { Component } from 'react';
import _ from 'underscore';
import { Map, Marker, InfoWindow } from 'components/maps';

const getMarkers = (arriving, delivering) => {
  return [arriving, delivering]
    .map((loc, idx) =>
      loc && loc.length ? { seq: idx + 1, address: loc[0] } : null,
    )
    .filter(Boolean);
};

const getCenter = (arriving, delivering) => {
  if (arriving && arriving.length) {
    return _.pick(arriving[0], 'lat', 'lng');
  }
  if (delivering && delivering.length) {
    return _.pick(delivering[0], 'lat', 'lng');
  }
  return { lat: 34.025327, lng: -118.375244 };
};

export default class OrderMap extends Component {
  shouldComponentUpdate(nextProps) {
    return (
      !_.isEqual(this.props.arriving, nextProps.arriving) ||
      !_.isEqual(this.props.delivering, nextProps.delivering)
    );
  }

  render() {
    const { arriving, delivering } = this.props;
    const markers = getMarkers(arriving, delivering);
    const center = getCenter(arriving, delivering);

    return (
      <Map
        className="h-80 sm:h-96 lg:h-112"
        defaultZoom={10}
        defaultCenter={center}
        center={center}
      >
        {markers.map((m) => (
          <React.Fragment key={m.address._id}>
            <Marker
              icon={{ url: `/img/stop-${m.seq}.png` }}
              position={{ lat: m.address.lat, lng: m.address.lng }}
            />
            <InfoWindow position={{ lat: m.address.lat, lng: m.address.lng }}>
              <div>{m.address.address}</div>
            </InfoWindow>
          </React.Fragment>
        ))}
      </Map>
    );
  }
}
